import React, { useContext, useEffect, useState } from "react";
import { GoPlus } from "react-icons/go";
import { CiFilter } from "react-icons/ci";
import { MdDeleteOutline } from "react-icons/md";
import ToggleBtn from "../SharedComponents/ToggleBtn";
import SetupInput from "../SharedComponents/SetupInput";
import { MdSort } from "react-icons/md";
import { RiDeleteBin2Fill } from "react-icons/ri";
import { IoSearch } from "react-icons/io5";
import { FiEdit } from "react-icons/fi";
import axios from "axios";
import SetupTittle from "../SharedComponents/SetupTittle";
import SetupContainer from "../SharedComponents/SetupContainer";
import Box from "../SharedComponents/Box";
import SubmitBtn from "../SharedComponents/SubmitBtn";
import SetupRadio from "../SharedComponents/SetupRadio";
import HistoryTable from "../SharedComponents/HistoryTable";
import SetupDropDown from "../SharedComponents/SetupDropdown";
import Swal from "sweetalert2";
import GetLocalStorageUserId from "../../sharedComponents/GetLocalStorageuserId";
import { contextProvider } from "../SetupPagesContextApi/SetupPagesContextApi";

const RouteSetup = () => {
  const backendUrl = process.env.REACT_APP_API_URL;
  const [fetchedData, setFetchedData] = useState([]);
  const [refetch, setRefetch] = useState(false);
  useEffect(() => {
    axios
      .get(`${backendUrl}Route`)
      .then((res) => setFetchedData(res.data))
      .catch((err) => console.log(err.message));
  }, [backendUrl,refetch]);

  // input fields handle.
  const initialValue = {
    id: 0,
    companyId: "",
    routeName: "",
    startingArea: "",
    endingArea: "",
    routeCost: "",
    isActive: "",
    creatorId: GetLocalStorageUserId(),
    creationDate: new Date(),
    modifierId: GetLocalStorageUserId(),
    modificationDate: new Date(),
    branchId: "",
    branchName: "string",
  };

  const [formData, setFormData] = useState(initialValue);
  const [willUpdate, setWillUpdate] = useState(false);

  const update = (data) => {
    setFormData({ ...formData, ...data });
  };
  const { handleDataReload } = useContext(contextProvider);
  const formHandle = (e) => {
    e.preventDefault();
    console.log({ ...formData });

    if (!willUpdate) {
      axios
        .post(`${backendUrl}Route`, { ...formData })

        .then((res) => {
          console.log(res)
          if (res.status === 201) {
            Swal.fire({
              title: `Route Created Successfully`,
              icon: "success",
            });
            setRefetch((prev) => !prev);
            setFormData(initialValue);
            setWillUpdate(false);
            handleDataReload();
          }
          
        })
        .catch((err) => console.log(err.message));
    }

    if (willUpdate) {
      console.log(formData)
      axios
        .put(`${backendUrl}Route/${formData.id}`, { ...formData })

        .then((res) => {
          console.log(res);
          if (res.status === 204) {
            Swal.fire({
              title: `Route Updated Successfully`,
              icon: "success",
            });
            setRefetch((prev) => !prev);
            setFormData(initialValue);
            setWillUpdate(false);
            handleDataReload();
          }
        })
        .catch((err) => console.log(err.message));
    }


  };
  return (
    <div>
      {/* create new route. */}
      <Box top>
        <SetupTittle text="Route" />
        <SetupContainer>
          <form onSubmit={formHandle}>
            <div className="grid lg:grid-cols-2 gap-y-4 grid-cols-1 lg:gap-y-[35px] lg:gap-x-[125px]">
              <SetupInput
                name="routeName"
                type="text"
                placeHolder="Route name"
                allTimeValue={formData.routeName}
                valueUpdate={(e) => update({ routeName: e.target.value })}
              />
              <SetupDropDown
                dataOf="company"
                allTimeValue={formData.companyId}
                valueUpdate={(e) => update({ companyId: parseInt(e.target.value) })}
                placeHolder="Company name"
                name="companyId"
              ></SetupDropDown>

              <SetupInput
                name="startPoint"
                type="text"
                placeHolder="Start point"
                allTimeValue={formData.startingArea}
                valueUpdate={(e) => update({ startingArea: e.target.value })}
              />

              <SetupInput
                name="endPoing"
                type="text"
                placeHolder="End point"
                allTimeValue={formData.endingArea}
                valueUpdate={(e) => update({ endingArea: e.target.value })}
              />

              <SetupInput
                name="totalPrice"
                type="number"
                placeHolder="cost"
                allTimeValue={formData.routeCost}
                valueUpdate={(e) => update({ routeCost: parseInt(e.target.value) })}
              />
              <SetupDropDown // need to change
                dataOf="branch"
                allTimeValue={formData.branchId}
                valueUpdate={(e) => update({ branchId: parseInt(e.target.value) })}
                placeHolder="Branch"
                name="branchId"
              ></SetupDropDown>
              <SetupRadio
                name="isActive"
                placeHolder="Route status?"
                allTimeValue={formData.isActive}
                valueUpdate={(data) => update({ isActive: data })}
              />
            </div>

            <SubmitBtn text={willUpdate ? "Update" : "Create"} />
            <SubmitBtn
              onClick={() => {
                setWillUpdate(false);
                update(initialValue);
              }}
              styleClass={!willUpdate && "hidden"}
              text="Cancel"
            />
          </form>
        </SetupContainer>
      </Box>

      <Box>
        <SetupTittle text="History" />
        <SetupContainer>
          <HistoryTable
            editCallBack={(data) => {
              update(data);
              setWillUpdate(true);
            }}
            fetchedData={fetchedData}
            headers={[
              "Route name",
              "cost",
              // "Company name",
              "Start point",
              "End point",
              "Branch",
              "Status",
            ]}
            row={[
              "routeName",
              "routeCost",
              // "companyId",
              "startingArea",
              "endingArea",
              "branchName",
              "isActive",
            ]}
            extraFields={["branchId"]}
          />
        </SetupContainer>
      </Box>
    </div>
  );
};

export default RouteSetup;
